import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Post_To_MongoDB_No_Alert } from "../../api/Post_To_MongoDB_No_Alert";

function GSPTeacherUnSub() {
  const { TeacherEmail, Schoolid } = useParams();

  const [status, setStatus] = useState(false);

  useEffect(() => {
    Post_To_MongoDB_No_Alert(
      {
        Teacher_Email: TeacherEmail,
        School_id: Schoolid,
        DateTime: new Date(),
      },
      "Emails",
      "GSPBookingEmailUnSub",
      setStatus
    );
    // Add any additional logic you want to trigger on load here
  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        marginTop: "50px",
      }}
    >
      <h1 style={{ color: "#333", fontSize: "2.5em" }}>
        Unsubscribe Confirmation
      </h1>
      <h2 style={{ color: "#555", fontSize: "1.5em" }}>{TeacherEmail}</h2>
      <p style={{ color: "#777", fontSize: "1em" }}>
        The above email has now been unsubscribed from hearing from us every
        time your students book.
        <br></br>
        <br></br>
        Please contact schools@investin.org if you wish to re-subscribe.
      </p>
    </div>
  );
}

export default GSPTeacherUnSub;
